<template>
    <div class="box" ref="detail">
        <div ref="box">
            <div class="topContent">
                <img class="sign" :src="topImg" alt="" :class="{'signBottom': (stage === 'first' && oneList.length) || (sortType === 'success')}" >
                <div class="intr" ref="btn">
                    <a href="javascript:;" class="introduction activity" @click="intrShow">活动介绍</a>
                    <a href="javascript:;" class="rule activity" @click="ruleShow">活动规则</a>
                </div>
                <img v-if="(stage === 'first' && oneList.length) || (sortType === 'success')" class="link" src="http://source.weicistudy.com/draw/second-link.png" alt="">
            </div>
            <!--<winner-list :stage="stage"></winner-list>-->
            <!--<winner-list imgPosition="bottom" v-if="stage === 'second'"></winner-list>-->
            <template v-if="stage === 'second' && twoList.length">
                <winner-list :stage="stage" :winnerList='twoList'></winner-list>
                <winner-list imgPosition="bottom" :winnerList='oneList'></winner-list>
            </template>
            <template v-else>
                <winner-list :winnerList='oneList' v-if="oneList.length"></winner-list>
            </template>

            <img class="tips" src="http://source.weicistudy.com/draw/tips.png" alt="">
        </div>
        <activity-introduction v-show="intrFlag" @close="intrHide"></activity-introduction>
        <activity-rules v-show="ruleFlag" @close="ruleHide" :stage="sortType === 'success' ? 'first': stage" :state="ruleFlag"></activity-rules>
    </div>
</template>

<script>
    /*奖品抽完、未中奖、第二轮报名成功以及第二轮无资格都由这个页面来展示，stage区分阶段，sortType区分三种类别*/
    import WinnerList from '@/components/lottery/WinnerList'
    import ActivityIntroduction from '@/components/lottery/ActivityIntroduction'
    import ActivityRules from '@/components/lottery/ActivityRules'
    import LotteryService from '@/service/LotteryService'
    export default {
        name: "DisplayDetails",
        components: {
            WinnerList, ActivityIntroduction, ActivityRules
        },
        data () {
            return {
                userCode: '',
                session: '',
                appId: 0,
                bannerId: 0,
                stage: 'first', // 当前阶段 first:第一阶段；second:第二阶段
                intrFlag: false, // 活动说明隐藏显示标志
                ruleFlag: false, // 活动规则隐藏显示标志
                oneList: [], // 第一波获奖名单
                twoList: [], // 第二波获奖名单
                isHasData: false, // 获奖名单数据是否得到
                baseUrl: process.env.BASE_URL,
                sortType: 'nowin', // 区分是抽完奖还是未中奖 empty：抽完；success:报名成功；unqualified:无资格；nowin:未中奖
                height: 0
            }
        },
        created () {
            this.userCode = this.$route.query.user_code;
            this.session = this.$route.query.session;
            this.appId = this.$route.query.app_id;
            this.bannerId = this.$route.query.banner_id
            this.stage = this.$route.query.stage
            this.sortType = this.$route.query.sortType
            // this.init()
            this.initWinnerList();
            // console.log(1);
        },
        computed: {
          // topImg () {
          //     if (this.stage === 'second') {
          //         return this.baseUrl + 'images/second-prize-empty.png'
          //     } else {
          //         return this.baseUrl + 'images/first-prize-empty.png'
          //     }
          // }
            topImg () {
                // if (this.stage === 'second') {
                //     if (this.sortType === 'empty') {
                //         return this.baseUrl + 'images/second-prize-empty.png'
                //     } else if (this.sortType === 'unqualified') {
                //         return this.baseUrl + 'images/second-unqualified.png'
                //     }else if (this.sortType === 'success') {
                //         return this.baseUrl + 'images/sign-up-success.png'
                //     } else {
                //         return this.baseUrl + 'images/second-no-win.png'
                //     }
                // } else {
                //     if (this.sortType === 'empty') {
                //         return this.baseUrl + 'images/first-prize-empty.png'
                //     } else {
                //         return this.baseUrl + 'images/first-no-win.png'
                //     }
                //
                // }
                if (this.stage === 'second') {
                    if (this.sortType === 'empty') {
                        return 'http://source.weicistudy.com/draw/public/second-prize-empty.png'
                    } else if (this.sortType === 'unqualified') {
                        return 'http://source.weicistudy.com/draw/public/second-unqualified.png'
                    }else if (this.sortType === 'success') {
                        return 'http://source.weicistudy.com/draw/public/sign-up-success.png'
                    } else {
                        return 'http://source.weicistudy.com/draw/public/second-no-win.png'
                    }
                } else {
                    if (this.sortType === 'empty') {
                        return 'http://source.weicistudy.com/draw/public/first-prize-empty.png'
                    } else {
                        return 'http://source.weicistudy.com/draw/public/first-no-win.png'
                    }

                }
            }, // 根据条件引入图片
            // dataList () {
            //     return this.stage === 'second' ?  this.twoList : this.oneList
            // }, // 根据阶段传入数据
            marginBottom1 () {
                let _this = this
                return {
                    '.signBottom': (_this.stage === 'first' && _this.oneList.length) || (_this.sortType === 'success')
                }
            }
        },
        methods: {
            // init () {
            //     let _this = this;
            //     LotteryService.getInfo(this.userCode,this.session,this.appId,this.bannerId)
            //         .then(res => {
            //             if (res.data.result_code === 200) {
            //                 _this.status = res.data.info.activity_status;
            //                 _this.signUp = res.data.info.sign_up
            //                 _this.activityBatch = res.data.info.activity_batch
            //             }
            //         })
            //         .catch(error => {
            //             console.log(error)
            //         })
            // },
            initWinnerList () {
                let _this = this
                // console.log(1)
                LotteryService.list(_this.userCode, _this.session, _this.appId, _this.bannerId)
                    .then(res => {
                        // console.log(res);
                        if (res.data.result_code === 200) {
                            _this.oneList = res.data.one_list
                            _this.twoList = res.data.two_list
                            // _this.isHasData = true
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }, // 获取获奖名单
            intrHide () {
                this.intrFlag = false
            }, // 活动说明隐藏
            intrShow () {
                this.intrFlag = true
            }, // 活动说明显示
            ruleHide () {
                this.ruleFlag = false
            }, // 活动规则隐藏
            ruleShow () {
                this.ruleFlag = true
            }, // 活动规则显示
            touchHandle (e) {
                e.stopPropagation();
                e.preventDefault();
            }
        },
        mounted () {
            if (this.stage === 'second' && this.sortType !== 'success') {
                this.$refs.btn.style.bottom = '30px'
            }
            // this.$refs.detail.scrollTop = 0
        }
    }
</script>

<style scoped>
    .box {
        background-color: #FD7759;
    }
    .topContent {
        position: relative;
        z-index: 20;
        margin-bottom: 10px;
    }
    .topContent .link {
        position: absolute;
        left: 120px;
        bottom: -45px;
        width: 476px;
        z-index: 10;
    }
    .sign {
        width: 100%;
    }
    .signBottom {
        margin-bottom: -20px;
    }
    .intr {
        position: absolute;
        /*bottom:473px;*/
        top: 937px;
        left:0;
        width: 100%;
        text-align: center;
        z-index: 40;
    }
    .activity {
        /*position: relative;*/
        display: inline-block;
        width:166px;
        height:60px;
        /*z-index: 1000;*/
        line-height: 60px;
        font-size:26px;
        font-weight:400;
        color:rgba(255,255,255,1);
        background-size: 100% 100%;
        z-index: 50;
    }
    .introduction {
        margin-right:73px;
        background-image: url('http://source.weicistudy.com/draw/js_button.png');
    }
    .rule {
        background-image: url('http://source.weicistudy.com/draw/rule_button.png');
    }
    .tips {
        width: 464px;
        margin: 25px 0 36px 40px;
    }
</style>